import React, { useEffect } from "react";
import NotFound from "../../components/notfound.js"

const NotFoundPage = () => {
  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
        <NotFound/>
    </div>
  );
};
export default NotFoundPage;
